import React, { useEffect, useState } from 'react';
import { Card } from 'Components/Common/Card/Card';
import { Tag, Stack, Divider, IconButton, Whisper, Tooltip } from 'rsuite';
import api from 'Components/_helpers/api';
import CopyIcon from '@rsuite/icons/Copy';
import axios from 'axios';

const InvEsatusStack = (props) => {
  const { estatus, validationResult } = props;

  if (!validationResult.isValid) return <Tag color="red">Invalidación incorrecta</Tag>;

  if (estatus.estatusFirmado === 2) return <Tag color="red">Error de firma</Tag>;

  if (estatus.estatusRecibidoMH === 2) return <Tag color="red">Error Recepción MH</Tag>;

  return (
    <Stack wrap spacing={6}>
      {
        {
          3: <Tag color="orange">Recepción diferida</Tag>,
        }[estatus.estatusRecibidoMH]
      }
      {
        {
          0: <Tag color="orange">No Notificado</Tag>,
          2: <Tag color="red">No Notificado</Tag>,
        }[estatus.estatusCorreo]
      }
      {
        {
          1: <Tag color="green">DTE Anulado Correctamente</Tag>,
        }[estatus.estatusVigencia]
      }
    </Stack>
  );
};

export const Invalidation = (props) => {
  const { codigoGeneracion, dteType } = props;

  const [loading, setLoading] = useState(true);
  const [dteInvalidation, setDTEInvalidation] = useState({});

  const [catDefsRec, setCatDefsRec] = useState({ loading: true });

  const getCATDef_Rec = (dteInv) => {
    const reqs = [
      api.post(`${api.getUri()}CAT/CAT022`, { code: dteInv.invalidacion.motivo.tipDocResponsable }),
      api.post(`${api.getUri()}CAT/CAT022`, { code: dteInv.invalidacion.motivo.tipDocSolicita }),
    ];

    axios.all(reqs).then(
      axios.spread((tipoDocResponsable, tipoDocSolicita) => {
        const state = {
          loading: false,
          tipoDocResponsable: tipoDocResponsable.data.items.pop(),
          tipoDocSolicita: tipoDocSolicita.data.items.pop(),
        };

        setCatDefsRec(state);
      })
    );
  };

  const getInvalidationDetails = () => {
    setLoading(true);
    api.get(`${api.getUri()}${dteType}/DTE/Invalidation/${codigoGeneracion}`).then((response) => {
      const res = response.data.pop();
      setDTEInvalidation(res);
      getCATDef_Rec(res);
      setLoading(false);
    });
  };

  useEffect(() => {
    getInvalidationDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoGeneracion]);

  return (
    <Card header={'Información de anulación del DTE'}>
      {!loading && (
        <>
          <dl>
            <dt>Versión del DTE</dt>
            <dd>
              <Tag size="md" color="blue">
                {`Versión ${dteInvalidation.invalidacion.identificacion.version}`}
              </Tag>
            </dd>            
            <dt>Fecha y hora de anulación</dt>
            <dd>
              <Tag size="md">
                {dteInvalidation.invalidacion.identificacion.fecAnula} {dteInvalidation.invalidacion.identificacion.horAnula}
              </Tag>
            </dd>
            <dt>Código de generación de documento de anulación</dt>
            <dd>
              <Stack spacing={6}>
                <Tag size="md">{dteInvalidation.invalidacion.identificacion.codigoGeneracion}</Tag>
                <Whisper trigger="hover" placement={'auto'} speaker={<Tooltip>Copiar código de generación</Tooltip>}>
                  <IconButton
                    icon={<CopyIcon />}
                    size="xs"
                    onClick={() => {
                      navigator.clipboard.writeText(dteInvalidation.Invalidacion.identificacion.codigoGeneracion);
                    }}
                  />
                </Whisper>
              </Stack>
            </dd>
            {dteInvalidation.invalidacion.documento.codigoGeneracionR && (
              <>
                <dt>Código de generación de documento que reemplaza</dt>
                <dd>
                  <Stack spacing={6}>
                    <Tag size="md">{dteInvalidation.invalidacion.identificacion.codigoGeneracionR}</Tag>
                    <Whisper trigger="hover" placement={'auto'} speaker={<Tooltip>Copiar código de generación</Tooltip>}>
                      <IconButton
                        icon={<CopyIcon />}
                        size="xs"
                        onClick={() => {
                          navigator.clipboard.writeText(dteInvalidation.Invalidacion.identificacion.codigoGeneracionR);
                        }}
                      />
                    </Whisper>
                  </Stack>
                </dd>
              </>
            )}
            <dt>Tipo de anulación</dt>
            <dd>
              {
                {
                  1: '1 - Error en la Información del Documento Tributario Electrónico a invalidar.',
                  2: '2 - Rescindir de la operación realizada.',
                  3: '3 - Otro',
                }[dteInvalidation.invalidacion.motivo.tipoAnulacion]
              }
            </dd>
            <dt>Motivo de anulación</dt>
            <dd>
              <p>{dteInvalidation.invalidacion.motivo.motivoAnulacion}</p>
            </dd>
            {!catDefsRec.loading && (
              <>
                <dt>¿Quién solicita anulación?</dt>
                <dd>
                  <p>{`${dteInvalidation.invalidacion.motivo.nombreSolicita} (${catDefsRec.tipoDocSolicita.code} - ${catDefsRec.tipoDocSolicita.value} ${dteInvalidation.invalidacion.motivo.numDocSolicita})`}</p>
                </dd>
                <dt>Responsable de anulación</dt>
                <dd>
                  <p>{`${dteInvalidation.invalidacion.motivo.nombreResponsable} (${catDefsRec.tipoDocResponsable.code} - ${catDefsRec.tipoDocResponsable.value} ${dteInvalidation.invalidacion.motivo.numDocResponsable})`}</p>
                </dd>
              </>
            )}
            <dt>Estado resultado del procesamiento</dt>
            <dd>
              <Tag size="md">{dteInvalidation.recepcion.estado}</Tag>
            </dd>
            <dt>Sello de Recepción del DTE Aceptado</dt>
            <dd>
              <Tag size="md">{dteInvalidation.recepcion.selloRecibido}</Tag>
            </dd>
            <dt>Fecha y hora de procesamiento</dt>
            <dd>
              <Tag size="md">{dteInvalidation.recepcion.fhProcesamiento}</Tag>
            </dd>

            <dt>Código de Mensaje</dt>
            <dd>{dteInvalidation.recepcion.codigoMsg}</dd>
            <dt>Descripción del Mensaje</dt>
            <dd>{dteInvalidation.recepcion.descripcionMsg}</dd>
            {dteInvalidation.recepcion.observaciones?.length > 0 && (
              <>
                <dt>Detalle de observaciones de validación del DTE</dt>
                <dd>
                  <ul>
                    {dteInvalidation.recepcion.observaciones.map((o, i) => (
                      <li key={i}>{o}</li>
                    ))}
                  </ul>
                </dd>
              </>
            )}
            {dteInvalidation.firma.observaciones && (
              <>
                <dt>Detalle de observaciones de firma del DTE</dt>
                <dd>
                  <ul>
                    {dteInvalidation.firma.observaciones.map((o) => (
                      <li>{o}</li>
                    ))}
                  </ul>
                </dd>
              </>
            )}
          </dl>       
          <div>
                <InvEsatusStack estatus={dteInvalidation.estatus} validationResult={dteInvalidation.validationResult} />
            </div>   
          {dteInvalidation.validationResult.errors.length > 0 && (
            <>
              <Divider>¿Por qué no es válido este documento?</Divider>
              <div>
                <ul>
                  {dteInvalidation.validationResult.errors.map((e) => (
                    <li>{e}</li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </>
      )}
    </Card>
  );
};
